/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import MSCombi3D from './mscombi3d';
import Column3DDataset from '../_internal/datasets/column3d';
import LineDataset from '../_internal/datasets/line';
import Column3DGroup from '../_internal/datasets/groups/column.multiseries';
/**
 * Creates class MSColumnLine3D
 */
class MSColumnLine3D extends MSCombi3D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'MSColumnLine3D';
  }
  /**
   * Creates constructor function for MSColumnLine3D class
   */
  constructor () {
    super();
    this.defaultPlotShadow = 1;
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'MSColumnLine3D';
  }
  /**
   * Sets default configuration of chart elements
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.is3D = true;
    config.friendlyName = 'Multi-series Column and Line Chart';
    config.use3dlineshift = 1;
    config.showplotborder = 0;
    config.enablemousetracking = true;
  }
  /**
   * This method return the dataset definations for this charts
   * @param  {string} name type of dataset class
   * @return {Object}      dataset class
   */
  getDSdef (name) {
    return name === 'line' ? LineDataset : Column3DDataset;
  }
  /**
   * This method return the dataset-group definations for this charts
   * @param  {string} name is type of dataset group
   * @return {Object} <dataset group class>     dataset group class
   */
  getDSGroupdef (name) {
    return name === 'column3d' ? Column3DGroup : undefined;
  }
  /**
   * function to return dataset type applicable for this chart
   * @param   {string}  name  dataset type
   * @return  {string}        dataset type applicable for this chart
   */
  getDSType (name) {
    return name && name.toLowerCase() === 'line' ? 'line' : 'column3d';
  }
}
export default MSColumnLine3D;
